module.exports = __webpack_public_path__ + "static/img/partner-mech.a443ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-mech.png
// module id = y4Oq
// module chunks = 34